import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/ft_logo.png";
import Google from "../../assets/images/googleplay.png";
import Appstore from "../../assets/images/appstorebtn.png";

function Main() {
  return (
    <>
      <footer
        className="white_text"
        data-aos="fade-in"
        data-aos-duration={1500}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="logo_side">
                <div className="logo">
                  <Link to="/">
                    <img src={Logo} alt="Logo" style={{ width: "8vw" }} />
                  </Link>
                </div>
                <div className="news_letter">
                  <h3>Abonne-toi à notre newsletter</h3>
                  <p>
                    Reste informé(e) des nouveautés, tests, fonctionnalités IA
                    et avantages exclusifs.
                  </p>
                  <form>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Ton adresse e-mail"
                      />
                      <button className="btn">
                        <i className="icofont-paper-plane" />
                      </button>
                    </div>
                    <p className="note">
                      En validant, tu acceptes de recevoir les actualités
                      Neoori.
                    </p>
                  </form>
                </div>
                <ul className="contact_info">
                  <li>
                    <Link to="mailto:support@neoori.fr">support@neoori.fr</Link>
                  </li>
                  <li>
                    <Link to="tel:+212677947762">+33 6 77 94 77 62</Link>
                  </li>
                </ul>
                <ul className="social_media">
                  <li>
                    <Link to="/">
                      <i className="icofont-facebook" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <i className="icofont-twitter" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <i className="icofont-instagram" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <i className="icofont-pinterest" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="download_side">
                <h3>Télécharger l’application</h3>
                <p>Disponible prochainement sur :</p>
                <ul className="app_btn">
                  <li>
                    <Link to="/">
                      <img className="blue_img" src={Google} alt="" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <img className="blue_img" src={Appstore} alt="" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_bottom">
          <div className="container">
            <div className="ft_inner">
              <div className="copy_text">
                <p> Neoori 2025. Tous droits réservés.</p>
              </div>
              <ul className="links">
                <li>
                  <Link to="/">Accueil</Link>
                </li>
                <li>
                  <a href="#about">A propos</a>
                </li>
                <li>
                  <a href="#reviews">Avis</a>
                </li>

                <li>
                  <a href="#pricing">Prix</a>
                </li>
                <li>
                  <a href="#faq">Faq</a>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
              </ul>
              <div className="design_by">
                <p>
                  Conçu avec passion par{" "}
                  <Link to="/" target="blank">
                    TridiaHub
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Main;
